import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../config/authAxios";

const initialState = {
  status: null,
  loading: false,
  data: [],
  total: 0,
  error: "",
  message: "",
};

export const amountByAdminAction = createAsyncThunk(
  "amount-by-admin",
  async (data, { rejectWithValue }) => {
    try {
      const res = await axios.post(
        `/admins/api/manage/balance`,{
            appId: data?.app_id,
            amount: data?.amount,
            isCredit: data?.isCredit ,
            userId: data?.userId
        }
      );
      return res?.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const amountByAdminSlice = createSlice({
  name: "amount-by-admin",
  initialState,
  reducers: {
    resetData: (state) => {
      state.status = null;
      state.loading = false;
      state.data = [];
      state.total = 0;
      state.error = "";
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder.addCase(amountByAdminAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(amountByAdminAction.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action?.payload?.data;
      state.total = action?.payload?.totalCount;
      state.status = action?.payload?.status;
      state.message = action?.payload?.message;
    });
    builder.addCase(amountByAdminAction.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.status = action?.payload?.status;
      state.message = action?.payload?.message;
    });
  },
});

export const { resetData } = amountByAdminSlice.actions;

export const amountByAdminReducer = amountByAdminSlice.reducer;
